<template>
  <div class="login-component">
    <WovenBrand
      title="Quick |digital payments| for the digital business."
      description="Woven provides a new type of payment account. Built for businesses that need a faster, easier and more reliable way to move money."
      no-step
    />
    <div class="login-component__login">
      <Logo classes="mobile-logo" />
      <Help />
      <div class="form" v-if="step === 'login' && !loading">
        <FormHeader
          title="Login"
          description="Welcome! Kindly login to continue moving your money through a fast, easy and reliable means. "
        />
        <form v-on:submit.prevent="checkUser2FAStatus" class="input-group" action="">
          <InputV2
            placeholder="Email Address"
            type="email"
            :required="true"
            v-model="email"
          />
          <InputV2
            placeholder="Password"
            type="password"
            :required="true"
            v-model="password"
          />
          <div class="flex-end">
            <router-link to="/password-reset" class="reset-password"
              >Reset Password?</router-link
            >
          </div>
          <Button
            buttonName="Continue"
            classes="woven-color"
            buttonType="submit"
            :disabled="isFormValid ? false : true"
            :onClick="() => {}"
          >
          </Button>
          <div class="register">
            Don't have an account?
            <router-link to="/register">Create an account</router-link>
          </div>
        </form>
      </div>
      <div class="form totp_form" v-if="step === 'totp' && !loading">
          <FormHeader
            title="Two-Step Verification"
            description="To continue, enter the code from your Authenticator app."
          />
          <form @submit.prevent="login" class="input-group" action="">
            <div class="pin_inputs">
              <input
              ref="pinOne"
              :type="pinTypes.pinOne"
              v-model="pinOne"
              @input="handleInput($event, 'pinOne', 'pinTwo')"
              @keydown="handleKeydown($event, 'pinOne')"
              @paste="handlePaste($event)"
              @focus="handleFocus($event)"
              maxlength="1"
              class="pin-input"
              autocomplete="off"
              autocorrect="off"
              autocapitalize="off"
              spellcheck="false"
              :readonly="pinReadonly"
              :style="pinStyle"
            />
            <input
              ref="pinTwo"
              :type="pinTypes.pinTwo"
              v-model="pinTwo"
              @input="handleInput($event, 'pinTwo', 'pinThree')"
              @keydown="handleKeydown($event, 'pinTwo', 'pinOne')"
              @paste="handlePaste($event)"
              @focus="handleFocus($event)"
              maxlength="1"
              class="pin-input"
              autocomplete="off"
              autocorrect="off"
              autocapitalize="off"
              spellcheck="false"
              :readonly="pinReadonly"
              :style="pinStyle"
            />
            <input
              ref="pinThree"
              :type="pinTypes.pinThree"
              v-model="pinThree"
              @input="handleInput($event, 'pinThree', 'pinFour')"
              @keydown="handleKeydown($event, 'pinThree', 'pinTwo')"
              @paste="handlePaste($event)"
              @focus="handleFocus($event)"
              maxlength="1"
              class="pin-input"
              inputmode="numeric"
              pattern="[0-9]*"
              autocomplete="one-time-code"
              autocorrect="off"
              autocapitalize="off"
              spellcheck="false"
              :readonly="pinReadonly"
              :style="pinStyle"
            />
            <input
              ref="pinFour"
              :type="pinTypes.pinFour"
              v-model="pinFour"
              @input="handleInput($event, 'pinFour', 'pinFive')"
              @keydown="handleKeydown($event, 'pinFour', 'pinThree')"
              @paste="handlePaste($event)"
              @focus="handleFocus($event)"
              maxlength="1"
              class="pin-input"
              inputmode="numeric"
              pattern="[0-9]*"
              autocomplete="one-time-code"
              autocorrect="off"
              autocapitalize="off"
              spellcheck="false"
              :readonly="pinReadonly"
              :style="pinStyle"
            />
            <input
              ref="pinFive"
              :type="pinTypes.pinFive"
              v-model="pinFive"
              @input="handleInput($event, 'pinFive', 'pinSix')"
              @keydown="handleKeydown($event, 'pinFive', 'pinFour')"
              @paste="handlePaste($event)"
              @focus="handleFocus($event)"
              maxlength="1"
              class="pin-input"
              inputmode="numeric"
              pattern="[0-9]*"
              autocomplete="one-time-code"
              autocorrect="off"
              autocapitalize="off"
              spellcheck="false"
              :readonly="pinReadonly"
              :style="pinStyle"
            />
            <input
              ref="pinSix"
              :type="pinTypes.pinSix"
              v-model="pinSix"
              @input="handleInput($event, 'pinSix', null)"
              @keydown="handleKeydown($event, 'pinSix', 'pinFive')"
              @paste="handlePaste($event)"
              @focus="handleFocus($event)"
              maxlength="1"
              class="pin-input"
              inputmode="numeric"
              pattern="[0-9]*"
              autocomplete="one-time-code"
              autocorrect="off"
              autocapitalize="off"
              spellcheck="false"
              :readonly="pinReadonly"
              :style="pinStyle"
            />
            </div>
            <div style="display: flex; align-items: center; justify-content: center; margin-top: 20px; width: 100%;">
                <div class="" style="display: flex; align-items: center; justify-content: center; border: 1px solid #e00b5b3b; width: fit-content; padding: 8px; border-radius: 16px; color: #e00b5b; background-color: #e00b5b17; cursor: pointer; gap: 4px;" @click="handlePaste(null)">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" style="height: 16px;"><path d="M439.4 96L448 96C483.3 96 512 124.7 512 160L512 512C512 547.3 483.3 576 448 576L192 576C156.7 576 128 547.3 128 512L128 160C128 124.7 156.7 96 192 96L200.6 96C211.6 76.9 232.3 64 256 64L384 64C407.7 64 428.4 76.9 439.4 96zM376 176C389.3 176 400 165.3 400 152C400 138.7 389.3 128 376 128L264 128C250.7 128 240 138.7 240 152C240 165.3 250.7 176 264 176L376 176zM256 320C256 302.3 241.7 288 224 288C206.3 288 192 302.3 192 320C192 337.7 206.3 352 224 352C241.7 352 256 337.7 256 320zM288 320C288 333.3 298.7 344 312 344L424 344C437.3 344 448 333.3 448 320C448 306.7 437.3 296 424 296L312 296C298.7 296 288 306.7 288 320zM288 448C288 461.3 298.7 472 312 472L424 472C437.3 472 448 461.3 448 448C448 434.7 437.3 424 424 424L312 424C298.7 424 288 434.7 288 448zM224 480C241.7 480 256 465.7 256 448C256 430.3 241.7 416 224 416C206.3 416 192 430.3 192 448C192 465.7 206.3 480 224 480z" fill="#e00b5b"/></svg>
                  <span style="position: relative; top: 2px;">Paste from clipboard</span>
                </div>
            </div>
            <Button
              button-name="Login"
              classes="woven-color"
              button-type="submit"
              :disabled="isFormValid ? false : true"
              :on-click="() => {}"
            />
          </form>
      </div>
      <div class="form totp_form" v-if="step === 'totp-signup' && otpsignupData && !loading">
        <FormHeader
          title="Two-Step Verification"
          :description="otpsignupData.message"
        />
        <form @submit.prevent="verify2FA" class="input-group" action="" autocomplete="off">
          <div class="" style="margin-bottom: 20px; display: flex; justify-content: center;">
            <img :src="otpsignupData.qr_code" alt="" style="height: 212px; width: 212px; margin: auto;">
          </div>
          <div class="pin_inputs">
            <input
              ref="pinOne"
              :type="pinTypes.pinOne"
              v-model="pinOne"
              @input="handleInput($event, 'pinOne', 'pinTwo')"
              @keydown="handleKeydown($event, 'pinOne')"
              @focus="handleFocus($event)"
              maxlength="1"
              class="pin-input"
              :readonly="pinReadonly"
              name="totp-one"               
              autocomplete="off"            
              inputmode="numeric"           
            />
            <input
              ref="pinTwo"
              :type="pinTypes.pinTwo"
              v-model="pinTwo"
              @input="handleInput($event, 'pinTwo', 'pinThree')"
              @keydown="handleKeydown($event, 'pinTwo', 'pinOne')"
              @focus="handleFocus($event)"
              maxlength="1"
              class="pin-input"
              :readonly="pinReadonly"
              name="totp-two"
              autocomplete="off"
              inputmode="numeric"
            />
            <input
              ref="pinThree"
              :type="pinTypes.pinThree"
              v-model="pinThree"
              @input="handleInput($event, 'pinThree', 'pinFour')"
              @keydown="handleKeydown($event, 'pinThree', 'pinTwo')"
              @focus="handleFocus($event)"
              maxlength="1"
              class="pin-input"
              :readonly="pinReadonly"
              name="totp-three"
              autocomplete="off"
              inputmode="numeric"
            />
            <input
              ref="pinFour"
              :type="pinTypes.pinFour"
              v-model="pinFour"
              @input="handleInput($event, 'pinFour', 'pinFive')"
              @keydown="handleKeydown($event, 'pinFour', 'pinThree')"
              @focus="handleFocus($event)"
              maxlength="1"
              class="pin-input"
              :readonly="pinReadonly"
              name="totp-four"
              autocomplete="off"
              inputmode="numeric"
            />
            <input
              ref="pinFive"
              :type="pinTypes.pinFive"
              v-model="pinFive"
              @input="handleInput($event, 'pinFive', 'pinSix')"
              @keydown="handleKeydown($event, 'pinFive', 'pinFour')"
              @focus="handleFocus($event)"
              maxlength="1"
              class="pin-input"
              :readonly="pinReadonly"
              name="totp-five"
              autocomplete="off"
              inputmode="numeric"
            />
            <input
              ref="pinSix"
              :type="pinTypes.pinSix"
              v-model="pinSix"
              @input="handleInput($event, 'pinSix', null)"
              @keydown="handleKeydown($event, 'pinSix', 'pinFive')"
              @focus="handleFocus($event)"
              maxlength="1"
              class="pin-input"
              :readonly="pinReadonly"
              name="totp-six"
              autocomplete="off"
              inputmode="numeric"
            />
          </div>
          <div style="display: flex; align-items: center; justify-content: center; margin-top: 20px; width: 100%;">
                <div class="" style="display: flex; align-items: center; justify-content: center; border: 1px solid #e00b5b3b; width: fit-content; padding: 8px; border-radius: 16px; color: #e00b5b; background-color: #e00b5b17; cursor: pointer; gap: 4px;" @click="handlePaste(null)">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" style="height: 16px;"><path d="M439.4 96L448 96C483.3 96 512 124.7 512 160L512 512C512 547.3 483.3 576 448 576L192 576C156.7 576 128 547.3 128 512L128 160C128 124.7 156.7 96 192 96L200.6 96C211.6 76.9 232.3 64 256 64L384 64C407.7 64 428.4 76.9 439.4 96zM376 176C389.3 176 400 165.3 400 152C400 138.7 389.3 128 376 128L264 128C250.7 128 240 138.7 240 152C240 165.3 250.7 176 264 176L376 176zM256 320C256 302.3 241.7 288 224 288C206.3 288 192 302.3 192 320C192 337.7 206.3 352 224 352C241.7 352 256 337.7 256 320zM288 320C288 333.3 298.7 344 312 344L424 344C437.3 344 448 333.3 448 320C448 306.7 437.3 296 424 296L312 296C298.7 296 288 306.7 288 320zM288 448C288 461.3 298.7 472 312 472L424 472C437.3 472 448 461.3 448 448C448 434.7 437.3 424 424 424L312 424C298.7 424 288 434.7 288 448zM224 480C241.7 480 256 465.7 256 448C256 430.3 241.7 416 224 416C206.3 416 192 430.3 192 448C192 465.7 206.3 480 224 480z" fill="#e00b5b"/></svg>
                  <span style="position: relative; top: 2px;">Paste from clipboard</span>
                </div>
          </div>
          <Button
            button-name="Submit"
            classes="woven-color"
            button-type="submit"
            :disabled="disabled"
            :on-click="() => {}"
          />
        </form>
      </div>
      <div class="form" v-if="loading"
        style="
          display: flex;
          flex-direction: column;
          gap: 20px;
          justify-content: center;
          align-items: center;
          min-height: 300px;
        "
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          style="height: 40px; width: 40px"
          class="rolling-icon"
        >
          <path
            d="M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z"
            style="fill: red"
          />
        </svg>
      </div>
      <BackgroundImage classes="mobile-background-image" />
      <WovenStrip :loading="disabled" />
    </div>
  </div>
</template>

<script>
import WovenBrand from "@/components/wovenbrand.vue";
import FormHeader from "@/components/formheader.vue";
import InputV2 from "@/components/inputv2.vue";
import Button from "@/components/button.vue";
import WovenStrip from "@/components/wovenstrip.vue";
import Help from "@/components/help.vue";
import Logo from "@/components/logo";
import BackgroundImage from "@/components/backgroundlogo";

export default {
  name: "Login",
  metaInfo: {
    title: "Login",
  },
  components: {
    WovenBrand,
    FormHeader,
    InputV2,
    Button,
    WovenStrip,
    Help,
    Logo,
    BackgroundImage
  },
  data() {
    return {
      email: "",
      password: "",
      disabled: false,
      error: false,
      step: "login",
      otpsignupData: null,
      loading: false,
      pinOne: "",
      pinTwo: "",
      pinThree: "",
      pinFour: "",
      pinFive: "",
      pinSix: "",
      pinReadonly: true,
      // Track input types for each pin individually
      pinTypes: {
        pinOne: "text",
        pinTwo: "text", 
        pinThree: "text",
        pinFour: "text",
        pinFive: "text",
        pinSix: "text"
      }
    };
  },
  watch: {
    step: function () {
      this.validate();
      this.pinReadonly = true;
      this.resetPinTypes();
    },
    email: function () {
      this.validate();
    },
    password: function () {
      this.validate();
    },
    pinOne: function (newVal) {
      this.validate();
    },
    pinTwo: function (newVal) {
      this.validate();
    },
    pinThree: function (newVal) {
      this.validate();
    },
    pinFour: function (newVal) {
      this.validate();
    },
    pinFive: function (newVal) {
      this.validate();
    },
    pinSix: function (newVal) {
      this.validate();
    },
  },
  computed: {
    isFormValid() {
      return (
        this.email !== "" &&
        this.password !== "" &&
        !this.loading &&
        (this.step === "login" || (this.pinOne && this.pinTwo && this.pinThree && this.pinFour && this.pinFive && this.pinSix))
      );
    },
    pinStyle() {
      return {
        '-webkit-text-security': 'disc',
        'text-security': 'disc'
      };
    }
  },
  methods: {
    validate() {
      const isStepValid = this.step === "login" ? true : this.pinOne && this.pinTwo && this.pinThree && this.pinFour && this.pinFive && this.pinSix;
      const isValid = this.email !== "" && this.password !== "" && isStepValid;
      if (!isValid) {
        this.disabled = true;
      } else {
        this.disabled = false;
      }
    },
    handleFocus(event) {
      this.pinReadonly = false;
    },
    resetPinTypes() {
      this.pinTypes = {
        pinOne: "text",
        pinTwo: "text", 
        pinThree: "text",
        pinFour: "text",
        pinFive: "text",
        pinSix: "text"
      };
    },
    async checkUser2FAStatus() {
      try {
        this.loading = true;
        const response = await this.$http.post(`totp/admin/check`, {
          email: this.email.trim(),
          password: this.password
        });
        const data = response.body.data;
        this.loading = false;
        if (data.has_totp) {
          this.step = "totp";
        } else {
          this.step = "totp-signup";
          this.disabled = true;
          this.signup2fa();
        }
      } catch (error) {
          this.loading = false;
          if(error.status === 400){
            this.$notify({
              group: "notifications-default",
              type: "error text-white",
              title: "Error",
              text: "Incorrect email or password",
            });
          }else{
            this.$notify({
              group: "notifications-default",
              type: "error text-white",
              title: "Error",
              text: error.body.message,
            });
          }
      }
    },
    async verify2FA() {
      try {
        this.loading = true;
        const response = await this.$http.post(`totp/admin/verify`, {
          "totp_code": this.pinOne + this.pinTwo + this.pinThree + this.pinFour + this.pinFive + this.pinSix,
          "action": "setup",
          "requestId": "optional-request-id"
        });
        this.loading = false;
        if(response.body.data.success) {
          if(this.otpsignupData.backup_codes && this.otpsignupData.manual_entry_key){
            this.downloadObjectAsTxt(this.otpsignupData);
          } else{
            this.$router.push({ name: "overview" });
          }
        }
      } catch (error) {
        this.loading = false;
        this.$notify({
          group: "notifications-default",
          type: "error text-white",
          title: "Error",
          text: error.body.message,
        });
      }
    },
    async signup2fa() {
      this.validate();
      this.disabled = true;
      this.loading = true;
      if (this.email !== "" && this.password !== "") {
        let requestObject = {
          email: this.email.trim(),
          password: this.password.trim(),
        };
        this.$store
          .dispatch("login", requestObject)
          .then(async () => {
            const signup2fares = await this.$http.post(`totp/admin/setup`, {
              "requestId": "optional-request-id"
            });
            const resdata = signup2fares.body.data;
            this.disabled = false;
            this.otpsignupData = resdata;
            this.loading = false;
          })
          .catch((error) => {
            this.$notify({
              group: "notifications-default",
              type: "error text-white",
              title: "Error",
              text: error.body.message,
            });
            this.error = true;
            this.disabled = false;
            this.loading = false;
            this.step = "login";
          });
      } else {
        this.validate();
      }
    },
    login() {
      this.loading = true;
      this.disabled = true;
      if (this.email !== "" && this.password !== "") {
        let requestObject = {
          email: this.email.trim(),
          password: this.password.trim(),
          totp_code: this.pinOne + this.pinTwo + this.pinThree + this.pinFour + this.pinFive + this.pinSix,
        };
        this.$store
          .dispatch("login", requestObject)
          .then((response) => {
            this.loading = false;
            this.$router.push({ name: "overview" });
            this.disabled = false;
          })
          .catch((error) => {
            this.loading = false;
            if (error.response && error.response.status === 401) {
              this.$store.dispatch("logout");
              this.$router.push({ name: "login" });
              this.$notify({
                group: "notifications-default",
                type: "error text-white",
                title: "Session Expired",
                text: "Your session has expired. Please log in again.",
              });
            } else {
              this.$notify({
                group: "notifications-default",
                type: "error text-white",
                title: "Error",
                text: error.body.message || "An unexpected error occurred.",
              });
            }
            this.error = true;
            this.disabled = false;
          });
      } else {
        if (this.email.value == "") {
          this.email.empty = true;
        }
        if (this.password.value == "") {
          this.password.empty = true;
        }
      }
    },
    downloadObjectAsTxt(data, fileName = 'backupcodes.txt') {
      try {
        let content = `Manual Entry Key:\n${data.manual_entry_key}\n\nBackup Codes:\n`;
        content += data.backup_codes.join("\n");
        const blob = new Blob([content], { type: 'text/plain' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(link.href);
        this.$router.push({ name: "overview" });
      } catch (error) {
        console.log(error);
      }
    },
    handleInput(event, currentPin, nextPin) {
      const value = event.target.value;
      if (!/^\d?$/.test(value)) {
        event.target.value = '';
        this[currentPin] = '';
        return;
      }
      this[currentPin] = value;
      if (value && nextPin) {
        this.$nextTick(() => {
          this.$refs[nextPin].focus();
        });
      }
    },
    handleKeydown(event, currentPin, previousPin) {
      if (event.key === "Backspace" && !this[currentPin] && previousPin) {
        this.$nextTick(() => {
          this.$refs[previousPin].focus();
        });
      }
    },
    async handlePaste(event = null) {
      if (event) event.preventDefault();
      try {
        const text = (event && event.clipboardData && event.clipboardData.getData('text')) || await navigator.clipboard.readText();
        if (!text) {
          this.$notify({
            group: 'notifications-default',
            type: 'error text-white',
            title: 'Error',
            text: 'Clipboard is empty.',
          });
          return;
        }
        const cleanedData = text.replace(/\D/g, '').slice(0, 6);
        if (!cleanedData) {
          this.$notify({
            group: 'notifications-default',
            type: 'error text-white',
            title: 'Error',
            text: 'Invalid clipboard data.',
          });
          return;
        }
        const pins = ['pinOne', 'pinTwo', 'pinThree', 'pinFour', 'pinFive', 'pinSix'];
        pins.forEach(pin => { this[pin] = ''; });
        [...cleanedData].forEach((digit, i) => { this[pins[i]] = digit; });
        const lastIndex = Math.min(cleanedData.length - 1, pins.length - 1);
        this.$nextTick(() => {
          let nextIndex;
          if(cleanedData.length === 6) {
            nextIndex = 5;
          } else {
            nextIndex = Math.min(lastIndex + 1, pins.length - 1);
          }
          this.$refs[pins[nextIndex]].focus();
        });
      } catch (err) {
          this.$notify({
            group: 'notifications-default',
            type: 'error text-white',
            title: 'Error',
            text: 'Invalid clipboard data.',
          });
      }
    }
  },
};
</script>

<style lang="scss">
.login-component .totp_form .form-header h1{
  text-align: center !important;
}
.login-component .totp_form .form-header p{
  text-align: center !important;
}
.pin_inputs{
  display: flex;
  justify-content: center;
  align-items: center;
}
  .pin_inputs input {
    width: 50px;
    height: 50px;
    font-size: 24px;
    text-align: center;
    margin: 0 5px;
    border: 1px solid #e00b5b;
    outline: none;
    border-radius: 8px;
  }
.rolling-icon {
  animation: spin 2s linear infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.login-component {
  background: #fff;
  height: 100vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  &__login {
    flex: 0.8;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    position: relative;
    height: 100vh;
    &__help {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      text-align: right;
      color: #616e7c;
      position: absolute;
      top: 64px;
      right: 64px;
      span {
        color: #000;
        text-decoration: underline;
      }
    }
    .form {
      max-width: 465px;
      button {
        width: 100%;
        height: 48px;
        margin-top: 24px;
        margin-bottom: 16px;
      }
      .register {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        color: #616e7c;
        a {
          color: #000;
          text-decoration: underline;
        }
      }
      .terms-condition {
        display: flex;
        align-items: center;
        svg {
          margin-right: 10px;
        }
        p {
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 16px;
          color: #616e7c;
        }
      }
    }
    .input-group {
      padding-top: 30px;
    }
  }
  .input-v2 {
    input {
      margin-bottom: 20px;
    }
  }
  .flex-end {
    display: flex;
    justify-content: flex-end;
  }
  .reset-password {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    text-align: right;
    color: #e00b5b;
    cursor: pointer;
  }
  .btn {
    svg {
      width: 20px;
      height: 20px;
    }
  }
  .woven-brand {
    flex: 0.2;
    height: 100vh;
    padding: 64px;
    max-width: 430px;
    min-width: 350px;
    &__description {
      padding-top: 32px;
    }
  }
  .mobile-logo {
    display: none;
  }
  .mobile-background-image {
    display: none;
  }
  @media screen and (max-width: 880px) {
    .mobile-background-image {
      display: block;
    }
    .woven-brand {
      display: none
    }
    .mobile-logo {
      display: block;
      position: absolute;
      top: 40px;
      left: 5%;
    }
    .help-component {
      top: 50px;
      right: 5%;
    }
    &__login {
      flex: 1;
      padding: 5%;
      .form {
        height: 60vh;
      }
    }
  }
}
</style>